// eslint-disable-next-line
import { lazy } from "react";

import {
  BackOffice,
  CctvDetailPage,
  ChangePassword,
  CreateMenu,
  CreatePermission,
  Datalake,
  Datasets,
  DataWarehouse,
  EditConfig,
  EditMenu,
  EditPermission,
  ListMenu,
  ListPermission,
  ListRole,
  ListUser,
  SortMenu,
} from "pages";
import Login from "pages/auth/login";
import CctvList from "pages/cctv/cctv-list/CctvList";
import DynamicDashboard from "pages/dynamicDashboard";

import PrivateLayout from "components/Layout/PrivateLayout/PrivateLayout";
import PrivateCreateMenus from "components/Layout/PrivateLayout/PrivateCreateMenus"
import PrivateEditMenus from 'components/Layout/PrivateLayout/PrivateEditMenus'
import PrivatePermission from "components/Layout/PrivateLayout/PrivatePermission";
import PrivateSettingRole from 'components/Layout/PrivateLayout/PrivateSettingRole'
import PrivateSortMenus from 'components/Layout/PrivateLayout/PrivateSortMenus'
import PrivateSettingUsers from 'components/Layout/PrivateLayout/PrivateSettingUsers'
import ForgotPassword from "pages/auth/forgot-password";
import ResetPassword from "pages/auth/reset-password";

const Dashboard = lazy(() => import("pages/dashboard"));

const routes: Routes[] = [
  {
    path: "/",
    name: "dashboard",
    component: <Dashboard />,
  },
    {
    path: "/back-office",
    name: "back-office",
    component: <BackOffice />,
  },
  {
    path: "/setting/datasets",
    name: "datasets",
    component: <Datasets />,
  },
  {
    path: "/setting/datalake",
    name: "datalake",
    component: (
      <PrivateLayout>
        <PrivatePermission permissions={["view.datalake"]}>
          <Datalake />
        </PrivatePermission>
      </PrivateLayout>
    ),
  },
  {
    path: "/setting/data-warehouse",
    name: "data-warehouse",
    component: (
      <PrivateLayout>
        <PrivatePermission permissions={["view.data_warehouse"]}>
          <DataWarehouse />
        </PrivatePermission>
      </PrivateLayout>
    ),
  },
  {
    path: "/:parent_menu/:menu/:source",
    name: "dynamic_menu",
    component: <DynamicDashboard />,
  },

  {
    name: "list_user",
    path: "/setting/users",
    component: (
      <PrivateLayout>
        <PrivateSettingUsers>
          <ListUser />
        </PrivateSettingUsers>
      </PrivateLayout>
    ),
  },
  // Role Management
  {
    name: "list_role",
    path: "/setting/roles",
    component: (
      <PrivateLayout>
        <PrivateSettingRole>
          <ListRole />
        </PrivateSettingRole>
      </PrivateLayout>
    ),
  },

  // Menu Managemen
  {
    name: "list_menu",
    path: "/setting/menus",
    component: (
      <PrivateLayout>
        <ListMenu />
      </PrivateLayout>
    ),
  },
  {
    name: "sort_menu",
    path: "/setting/menus/sort",
    component: (
      <PrivateLayout>
        <PrivateSortMenus>
          <SortMenu />
        </PrivateSortMenus>
      </PrivateLayout>
    ),
  },

  {
    name: "create_menu",
    path: "/setting/menus/create",
    hide: true,
    component: (
      <PrivateLayout>
        <PrivateCreateMenus>
          <CreateMenu />
        </PrivateCreateMenus>
      </PrivateLayout>
    ),
  },
  {
    name: "edit_menu",
    path: "/setting/menus/edit/:id",
    hide: true,
    component: (
      <PrivateLayout>
        <PrivateEditMenus>
          <EditMenu />
        </PrivateEditMenus>
      </PrivateLayout>
    ),
  },

  // Permission Managemen
  {
    name: "list_permission",
    path: "/setting/permissions",
    component: (
      <PrivateLayout>
        <PrivateSettingRole>
          <ListPermission />
        </PrivateSettingRole>
      </PrivateLayout>
    ),
  },
  {
    name: "create_permission",
    path: "/setting/permissions/create",
    hide: true,
    component: (
      <PrivateLayout>
        <PrivateSettingRole>
          <CreatePermission />
        </PrivateSettingRole>
      </PrivateLayout>
    ),
  },
  {
    name: "edit_permission",
    path: "/setting/permissions/edit/:id",
    hide: true,
    component: (
      <PrivateLayout>
        <PrivateSettingRole>
          <EditPermission />
        </PrivateSettingRole>
      </PrivateLayout>
    ),
  },

  {
    name: "list_cctv",
    path: "apps/cctv/:parent_menu/:menu",
    hide: true,
    component: <CctvList />,
  },
  {
    name: "detail_cctv_apps",
    path: "apps/cctv/:parent_menu/:menu/:id",
    hide: true,
    component: <CctvDetailPage />,
  },

  {
    name: "edit_config",
    path: "/setting/config",
    component: (
      <PrivateLayout>
        <PrivateSettingRole>
          <EditConfig />
        </PrivateSettingRole>
      </PrivateLayout>
    ),
  },
  {
    name: "login",
    path: "/login",
    hide: true,
    component: <Login />,
  },
  {
    name: "forgot_password",
    path: "/forgot-password",
    hide: true,
    component: <ForgotPassword />,
  },
  {
    name: "reset_password",
    path: "/reset-password",
    hide: true,
    component: <ResetPassword />,
  },
  {
    name: "update_password",
    path: "/setting/change-password",
    component: (
      <PrivateLayout>
        <ChangePassword />
      </PrivateLayout>
    ),
  },
];

export default routes;
